import api from '../api';
import { FIND_FEDERATED } from '../constants/actionTypes';


export const findFederated = (payload) => {
    return api.fetch(FIND_FEDERATED, api.config.findFederated(), api.http.post(payload))   
};
